import { Component } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NavigationService } from './services/navigation.service'; 
import * as firebase from 'firebase';
import {Router} from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Angular app';
  
  constructor(private router: Router){
     const config = {
        apiKey: "AIzaSyC2wdIIwG4Axi_LySXxrktc1vha-DYiJ38",
        authDomain: "angular-6-application.firebaseapp.com",
        databaseURL: "https://angular-6-application.firebaseio.com",
        projectId: "angular-6-application",
        storageBucket: "angular-6-application.appspot.com",
        messagingSenderId: "748448590078"
     };
    firebase.initializeApp(config);
    this.router.navigate(['admin-home']);
  }
}
